import { catchError, map, of } from 'rxjs';
import { NgxMaskDirective } from 'ngx-mask';
import { environment } from 'src/environments/environment';
import { SelectPesquisavelService } from '@shared/components/select-pesquisavel/select-pesquisavel.service';
import {
  PesquisaCodigoTributacaoModalComponent,
  PesquisaCodigoTributacaoModalData,
  PesquisaCodigoTributacaoModalResult,
} from '@shared/components/pesquisa-codigo-tributacao-modal/pesquisa-codigo-tributacao-modal.component';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CommonModule, DatePipe, formatDate } from '@angular/common';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { SelectionModel } from '@angular/cdk/collections';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule, MAT_DATE_LOCALE, DateAdapter } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxMaskPipe, provideNgxMask } from 'ngx-mask';

import { EmptyListComponent } from '@shared/components/empty-list/empty-list.component';
import { ExtracaoDadosData, ExtracaoDadosModalComponent, FiltroExtracao } from '@shared/components/extracao-dados-modal/extracao-dados-modal.component';
import { HeaderComponent } from '@shared/components/header/header.component';
import { LoadingBoxDefaultListComponent } from '@shared/components/loading-box-default-list/loading-box-default-list.component';
import { SelectPesquisavelComponent } from '@shared/components/select-pesquisavel/select-pesquisavel.component';
import { OrigemPedidoExportacaoEnum } from '@shared/enums/batch-extracao-dados/origem-pedido-exportacao.enum';
import { TipoExtracaoEnum } from '@shared/enums/batch-extracao-dados/tipo-extracao.enum';
import { ModeloDocumentoEnum } from '@shared/enums/dfe/modelo-documento.enum';
import { PeriodoBuscaEnum } from '@shared/enums/dfe/periodo-busca.enum';
import { FuncionalidadeEnum } from '@shared/enums/usuario/funcionalidade.enum';
import { ModuloEnum } from '@shared/enums/usuario/modulo.enum';
import { normalizarValorOrdenacao } from '@shared/helpers/ordenacao-tabela.helper';
import { AbntPipe } from '@shared/pipes/abnt.pipe';
import { AlertService, AlertType } from '@shared/services/alert.service';
import { ModeloDocumentoService } from '@shared/services/apis/dfe/modelo-documento.service';
import { PainelContadorService } from '@shared/services/apis/repo-dfe/painel-contador.service';
import { DanfeService } from '@shared/services/apis/report/danfe.service';
import { AuthService } from '@shared/services/apis/usuario/auth.service';
import { CustomDateAdapter } from '@shared/services/custom-date-adapter';
import { MaskService } from '@shared/services/mask.service';
import { ModeloDocumento } from '@shared/services/models/dfe/modelo-documento.model';
import { Empresa } from '@shared/services/models/usuario/empresa.model';
import { DownloadDocumentosFiscaisEmitidosRequest } from '@shared/services/requests/repo-dfe/download-documentos-fiscais-emitidos.request';
import { GetAllPainelContadorRequest } from '@shared/services/requests/repo-dfe/get-all-painel-contador.request';
import { ListarDocumentosFiscaisEmitidosRequest } from '@shared/services/requests/repo-dfe/listar-documentos-fiscais-emitidos.request';
import { GerarDanfeRequest } from '@shared/services/requests/report/gerar-danfe.request';
import { DownloadDocumentosFiscaisEmitidosResponse } from '@shared/services/responses/repo-dfe/download-documentos-fiscais-emitidos.response';
import { DocumentoFiscalEmitidoDownloadStruct } from '@shared/services/structs/repo-dfe/documento-fiscal-emitido-download.struct';
import { DocumentoFiscalEmitidoListStruct } from '@shared/services/structs/repo-dfe/documento-fiscal-emitido-list.struct';
import { UtilService } from '@shared/services/util.service';
import { LimitDateValidator } from '@shared/validators/limit-date.validator';
import { RelatorioCfopModalComponent } from './relatorio-cfop-modal/relatorio-cfop-modal.component';

@Component({
    selector: 'app-painel-contador',
    standalone: true,
    imports: [
        NgxMaskDirective,
        CommonModule,
        ReactiveFormsModule,
        MatBadgeModule,
        MatButtonModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatMenuModule,
        MatProgressSpinnerModule,
        MatSortModule,
        MatTableModule,
        MatTooltipModule,
        DatePipe,
        AbntPipe,
        NgxMaskPipe,
        EmptyListComponent,
        HeaderComponent,
        LoadingBoxDefaultListComponent,
        SelectPesquisavelComponent,
    ],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
        { provide: DateAdapter, useClass: CustomDateAdapter },
        provideNgxMask()
    ],
    templateUrl: './painel-contador.component.html',
    styleUrls: ['./painel-contador.component.css'],
})
export class PainelContadorComponent implements OnInit, OnDestroy {
    readonly masks = MaskService.getMasks();
    readonly moduloEnum = ModuloEnum.NotasFiscais;
    readonly funcionalidadeEnum = FuncionalidadeEnum.NotasFiscais_PainelContador;
    readonly modeloDocumentoEnum = ModeloDocumentoEnum;
    readonly tipoExtracaoEnum = TipoExtracaoEnum;
    readonly periodoEnum = PeriodoBuscaEnum;
    readonly limiteMeses = 2;
    readonly cfopMaskPatterns = { '0': { pattern: /[0-9?]/ } };
    readonly opcoesPeriodo = [
        { periodo: PeriodoBuscaEnum.Hoje, rotulo: 'hoje' },
        { periodo: PeriodoBuscaEnum.DaSemana, rotulo: 'desta semana' },
        { periodo: PeriodoBuscaEnum.DoMes, rotulo: 'do mês' },
        { periodo: PeriodoBuscaEnum.Ultimos30Dias, rotulo: 'últimos 30 dias' },
        { periodo: PeriodoBuscaEnum.DoIntervalo, rotulo: 'do intervalo' },
    ];
    /** isCacnelada mantém o nome: é a chave do filtro persistido e do PainelContadorFilterStruct do worker de extração. */
    readonly listaStatus = [
        { id: true, nome: 'Canceladas' },
        { id: false, nome: 'Autorizadas' },
    ];
    readonly displayedColumns = ['select', 'tipoNota', 'nota', 'emissao', 'cfop', 'emitente', 'destinatario', 'valor', 'acoes'];
    readonly dataSource = new MatTableDataSource<DocumentoFiscalEmitidoListStruct>();
    readonly selection = new SelectionModel<DocumentoFiscalEmitidoListStruct>(true, []);
    readonly filterForm = this.formBuilder.group({
        pesquisar: [''],
        tiposNota: [[] as number[]],
        listCnpj: [[] as string[]],
        isCacnelada: [null as boolean | null],
        serie: [''],
        cfop: [''],
        dataDe: [null as Date | null],
        dataAte: [null as Date | null],
        periodoSelecionado: [PeriodoBuscaEnum.DoMes],
    }, {
        validators: LimitDateValidator.rangeLimit(this.limiteMeses)
    });

    listaModeloDocumento: ModeloDocumento[] = [];
    listaEmpresas: Empresa[] = [];
    isSingleCompanyView = false;
    isLoading = false;
    isLoadingInitialData = true;
    isLoadingDownload = false;
    ultimaPagina = false;
    paginaAtual = 0;
    fullListSize = 0;
    valorTotal = 0;
    isMobileDrawerOpen = false;

    @ViewChild(MatSort) set matSort(sort: MatSort) {
        this.dataSource.sort = sort;
        this.dataSource.sortingDataAccessor = (item, property) => {
            switch (property) {
                case 'tipoNota': return normalizarValorOrdenacao(item.modeloDocumento);
                case 'nota': return normalizarValorOrdenacao(item.numero);
                case 'emissao': return normalizarValorOrdenacao(item.dataEmissao);
                case 'emitente': return normalizarValorOrdenacao(item.nomeEmitente);
                case 'destinatario': return normalizarValorOrdenacao(item.nomeDestinatario);
                default: return normalizarValorOrdenacao((item as any)[property]);
            }
        };
    }

    constructor(
    private selectPesquisavelService: SelectPesquisavelService,

        private formBuilder: FormBuilder,
        private painelContadorService: PainelContadorService,
        private authService: AuthService,
        private alertService: AlertService,
        private router: Router,
        private utilService: UtilService,
        private dialog: MatDialog,
        private danfeService: DanfeService,
        private modeloDocumentoService: ModeloDocumentoService,
    ) { }

    ngOnInit(): void {
        this.loadLookupData();
    }

    ngOnDestroy(): void {
        this.utilService.salvarFiltro(this.moduloEnum, this.funcionalidadeEnum, this.filterForm,
            ['/notas-fiscais/painel-contador/nfe/detalhe-nota', '/notas-fiscais/painel-contador/nfce/detalhe-nota', '/notas-fiscais/painel-contador/nfse/detalhe-nota']);
    }

    get periodoSelecionado(): PeriodoBuscaEnum {
        return this.filterForm.get('periodoSelecionado')!.value ?? PeriodoBuscaEnum.DoMes;
    }

    get periodoLabel(): string {
        return this.opcoesPeriodo.find(x => x.periodo === this.periodoSelecionado)?.rotulo ?? '';
    }

    get qtdFiltrosAvancados(): number {
        const value = this.filterForm.getRawValue();
        return (
            (value.tiposNota?.length ? 1 : 0) +
            (!this.isSingleCompanyView && value.listCnpj?.length ? 1 : 0) +
            (value.isCacnelada !== null && value.isCacnelada !== undefined ? 1 : 0) +
            (value.serie ? 1 : 0) +
            (value.cfop ? 1 : 0)
        );
    }

    /** Sem emitente escolhido, a busca considera todas as empresas disponíveis. */
    private get cnpjsEmitentes(): string[] {
        const listCnpj = this.filterForm.getRawValue().listCnpj;
        return listCnpj?.length ? listCnpj : this.listaEmpresas.map(x => x.cnpj);
    }

    loadLookupData(): void {
        this.isLoadingInitialData = true;
        this.modeloDocumentoService.listar().subscribe({
            next: (response) => {
                if (response.isError) {
                    this.alertService.show('Erro', response.errorDescription, AlertType.error);
                    this.isLoadingInitialData = false;
                    return;
                }
                this.listaModeloDocumento = response.modelos.filter(modelo =>
                    [ModeloDocumentoEnum.NFe, ModeloDocumentoEnum.NFCe, ModeloDocumentoEnum.NFSe].includes(modelo.idModeloDocumento));
                this.loadEmpresas();
            },
            error: (error) => {
                this.alertService.show('Erro ao carregar dados', error.message, AlertType.error);
                this.isLoadingInitialData = false;
            },
        });
    }

    loadEmpresas(): void {
        const userInfo = this.authService.getUserInfos();
        const empresaAtual: Empresa | undefined = userInfo.listaEmpresa.find(x => x.idEmpresa == userInfo.idEmpresa);
        if (!userInfo.listaEmpresasDoGrupo?.length) {
            this.isSingleCompanyView = true;
            this.listaEmpresas = empresaAtual ? [empresaAtual] : [];
        } else if (!userInfo.empresaPrincipalGrupo || userInfo.listaEmpresasDoGrupo.length === 1) {
            this.isSingleCompanyView = true;
            this.listaEmpresas = userInfo.listaEmpresasDoGrupo.filter(x => x.idEmpresa == userInfo.idEmpresa);
        } else {
            this.isSingleCompanyView = false;
            this.listaEmpresas = userInfo.listaEmpresasDoGrupo;
        }

        this.loadFilters();
        if (this.isSingleCompanyView) {
            this.filterForm.get('listCnpj')?.setValue(this.listaEmpresas[0] ? [this.listaEmpresas[0].cnpj] : []);
            this.filterForm.get('listCnpj')?.disable();
        }
        this.isLoadingInitialData = false;
        this.buscarNotasFiscais(true);
    }

    /** Filtro salvo antes do seletor de período (sem periodoSelecionado) é descartado. */
    loadFilters(): void {
        const filtroSalvo = this.utilService.obterFiltro(this.moduloEnum, this.funcionalidadeEnum);
        if (!filtroSalvo?.periodoSelecionado) return;
        this.filterForm.patchValue(filtroSalvo);
        const modelosPermitidos = this.listaModeloDocumento.map(x => x.idModeloDocumento);
        this.filterForm.get('tiposNota')?.setValue((this.filterForm.get('tiposNota')?.value ?? [])
            .filter((id: number) => modelosPermitidos.includes(id)));
    }

    aplicarFiltros(): void {
        this.buscarNotasFiscais(true);
    }

    limparFiltros(): void {
        const listCnpj = this.isSingleCompanyView ? this.filterForm.get('listCnpj')?.value : [];
        this.filterForm.patchValue({
            pesquisar: '',
            tiposNota: [],
            listCnpj,
            isCacnelada: null,
            serie: '',
            cfop: '',
            dataDe: null,
            dataAte: null,
            periodoSelecionado: PeriodoBuscaEnum.DoMes,
        });
        this.buscarNotasFiscais(true);
    }

    buscarNotasFiscais(novaBusca: boolean): void {
        if (this.isLoading) return;
        if (novaBusca) {
            this.paginaAtual = 0;
            this.ultimaPagina = false;
            this.selection.clear();
            this.dataSource.data = [];
        }
        this.isLoading = true;

        const form = this.filterForm.getRawValue();
        const { dataDe, dataAte } = this.getPeriodo();
        const request: ListarDocumentosFiscaisEmitidosRequest = {
            modelosDocumento: form.tiposNota ?? [],
            cnpjsEmitentes: this.cnpjsEmitentes,
            // Dia local sem fuso: o JSON de um Date sairia em UTC ("...Z").
            dataDe: formatDate(dataDe, 'yyyy-MM-dd', 'pt-BR'),
            dataAte: formatDate(dataAte, 'yyyy-MM-dd', 'pt-BR'),
            pesquisar: form.pesquisar || null,
            cfop: form.cfop || null,
            isCancelada: form.isCacnelada ?? null,
            serie: form.serie || null
        };

        this.painelContadorService.listarDocumentosFiscaisEmitidos(request, this.paginaAtual).subscribe({
            next: (response) => {
                this.isLoading = false;
                if (response.isError) {
                    this.alertService.show('Erro', response.errorDescription, AlertType.error);
                    return;
                }
                this.dataSource.data = [...this.dataSource.data, ...(response.documentos || [])];
                this.fullListSize = response.fullListSize;
                this.valorTotal = response.valorTotal;
                this.ultimaPagina = this.dataSource.data.length >= response.fullListSize;
            },
            error: (error) => {
                this.isLoading = false;
                this.alertService.show('Erro inesperado', error.message, AlertType.error);
            },
        });
    }

    proximaPagina(): void {
        if (this.ultimaPagina) return;
        this.paginaAtual++;
        this.buscarNotasFiscais(false);
    }

    selecionarPeriodo(periodo: PeriodoBuscaEnum, event: Event): void {
        this.filterForm.get('periodoSelecionado')?.setValue(periodo);
        if (periodo === PeriodoBuscaEnum.DoIntervalo) {
            event.stopPropagation();
            return;
        }
        this.filterForm.patchValue({ dataDe: null, dataAte: null });
        this.buscarNotasFiscais(true);
    }

    aplicarIntervalo(trigger: MatMenuTrigger): void {
        const value = this.filterForm.getRawValue();
        if (!value.dataDe || !value.dataAte) {
            this.alertService.show('Aviso', 'Informe a data inicial e a data final do intervalo.', AlertType.warning);
            return;
        }
        if (this.filterForm.invalid) {
            this.filterForm.markAllAsTouched();
            return;
        }
        trigger.closeMenu();
        this.buscarNotasFiscais(true);
    }

    cancelarIntervalo(trigger: MatMenuTrigger): void {
        this.filterForm.patchValue({ periodoSelecionado: PeriodoBuscaEnum.DoMes, dataDe: null, dataAte: null });
        trigger.closeMenu();
        this.buscarNotasFiscais(true);
    }

    onDateInput(event: Event, controlName: string): void {
        MaskService.onDateInput(event, this.filterForm.get(controlName));
    }

    toggleGavetaMobile(): void {
        this.isMobileDrawerOpen = !this.isMobileDrawerOpen;
    }

    fecharGavetaMobile(): void {
        this.isMobileDrawerOpen = false;
    }

    isAllSelected(): boolean {
        return this.selection.selected.length === this.dataSource.data.length;
    }

    toggleAllRows(): void {
        this.isAllSelected() ? this.selection.clear() : this.selection.select(...this.dataSource.data);
    }

    baixarNotasSelecionadas($event: Event): void {
        $event.stopPropagation();
        if (this.isLoadingDownload) return;

        if (this.selection.selected.length === 0) {
            this.alertService.show('Atenção', 'Selecione ao menos uma nota para baixar.', AlertType.warning);
            return;
        }

        this.isLoadingDownload = true;
        const request = new DownloadDocumentosFiscaisEmitidosRequest();
        request.documentos = this.selection.selected.map(nota => this.montarDownloadDocumentoFiscalEmitido(nota));

        this.painelContadorService.downloadDocumentosFiscaisEmitidos(request).subscribe({
            next: (response: DownloadDocumentosFiscaisEmitidosResponse) => {
                this.isLoadingDownload = false;
                if (response.isError) {
                    this.alertService.show('Erro', response.errorDescription, AlertType.error);
                    return;
                }
                this.dispararDownloadsDaResponse(response, 'notas.zip');
            },
            error: (err) => {
                this.isLoadingDownload = false;
                this.alertService.show('Erro', `Falha ao baixar arquivos: ${err.message}`, AlertType.error);
            }
        });
    }

    private montarDownloadDocumentoFiscalEmitido(nota: DocumentoFiscalEmitidoListStruct): DocumentoFiscalEmitidoDownloadStruct {
        const novoObj = new DocumentoFiscalEmitidoDownloadStruct();
        novoObj.idDocumentoFiscalEmitido = nota.idDocumentoFiscalEmitido;
        novoObj.origemDocumentoFiscalEmitido = nota.origemDocumentoFiscalEmitido;
        return novoObj;
    }

    private dispararDownloadsDaResponse(response: DownloadDocumentosFiscaisEmitidosResponse, fallbackName: string): void {
        if (response.arquivos && response.arquivos.length > 0) {
            // Quando ha multiplos zips (1 por CNPJ), dispara um download por vez com leve atraso
            // para evitar que o browser bloqueie downloads consecutivos.
            response.arquivos.forEach((arq, indice) => {
                setTimeout(() => this.dispararDownloadBase64(arq.fileContentBase64, arq.contentType, arq.fileName || fallbackName), indice * 350);
            });
            return;
        }

        this.dispararDownloadBase64(response.fileContentBase64 || '', response.contentType || 'application/octet-stream', response.fileName || fallbackName);
    }

    private dispararDownloadBase64(fileContentBase64: string, contentType: string, fileName: string): void {
        const byteCharacters = atob(fileContentBase64 || '');
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: contentType });

        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(link.href);
    }

    visualizarDanfe(nota: DocumentoFiscalEmitidoListStruct): void {
        nota.isLoadingDanfe = true;
        const request = new GerarDanfeRequest();
        request.nomeXml = nota.xml;

        this.danfeService.gerarDANFe(request).subscribe({
            next: (pdfBlob) => {
                // Verifica se o blob retornado é do tipo PDF, caso o endpoint retorne um JSON de erro.
                if (pdfBlob.type === 'application/pdf') {
                    const pdfUrl = URL.createObjectURL(pdfBlob);
                    window.open(pdfUrl, '_blank');
                    URL.revokeObjectURL(pdfUrl);
                } else {
                    this.alertService.show('Erro', 'Não foi possível gerar o PDF da nota.', AlertType.error);
                }
                nota.isLoadingDanfe = false;
            },
            error: () => {
                this.alertService.show('Erro inesperado', 'Ocorreu uma falha ao tentar gerar a DANFE.', AlertType.error);
                nota.isLoadingDanfe = false;
            }
        });
    }

    baixarXml(nota: DocumentoFiscalEmitidoListStruct): void {
        if (this.isLoadingDownload) return;

        nota.isLoading = true;
        const request = new DownloadDocumentosFiscaisEmitidosRequest();
        request.documentos = [this.montarDownloadDocumentoFiscalEmitido(nota)];

        this.painelContadorService.downloadDocumentosFiscaisEmitidos(request).subscribe({
            next: (response) => {
                nota.isLoading = false;
                if (response.isError) {
                    this.alertService.show('Erro', response.errorDescription, AlertType.error);
                    return;
                }
                this.dispararDownloadsDaResponse(response, nota.xml);
            },
            error: (err) => {
                nota.isLoading = false;
                this.alertService.show('Erro', `Falha ao baixar XML: ${err.message}`, AlertType.error);
            }
        });
    }

    verDetalhes(nota: DocumentoFiscalEmitidoListStruct): void {
        const modelo = nota.idModeloDocumento === ModeloDocumentoEnum.NFe ? 'nfe'
            : nota.idModeloDocumento === ModeloDocumentoEnum.NFCe ? 'nfce'
            : nota.idModeloDocumento === ModeloDocumentoEnum.NFSe ? 'nfse' : null;
        if (!modelo) return;
        this.router.navigate(['/notas-fiscais/painel-contador', modelo, 'detalhe-nota', nota.idDocumentoFiscalEmitido],
            { queryParams: { origemDocumentoFiscalEmitido: nota.origemDocumentoFiscalEmitido } });
    }

    fazerPedidoExtracao(idTipoExtracao: TipoExtracaoEnum): void {
        const titulo = idTipoExtracao === TipoExtracaoEnum.NotaXml ? 'XML de todas as notas com filtro'
            : idTipoExtracao === TipoExtracaoEnum.NotaCsv ? 'CSV da tabela com filtro'
            : 'Lista de produtos com filtro';

        const formValue = this.filterForm.getRawValue();
        const { dataDe, dataAte } = this.getPeriodo();
        const cnpjsEmitentes = this.cnpjsEmitentes;
        const filtrosMapeados: FiltroExtracao[] = [];

        // As chaves (formControlName) são os nomes do PainelContadorFilterStruct do worker de extração.
        if (formValue.tiposNota?.length) {
            filtrosMapeados.push({
                label: 'Tipos de Nota',
                formControlName: 'tiposNota',
                valor: formValue.tiposNota,
                valorExibicao: this.listaModeloDocumento
                    .filter(tipo => formValue.tiposNota!.includes(tipo.idModeloDocumento))
                    .map(tipo => tipo.nome)
            });
        }
        filtrosMapeados.push({
            label: 'Emitentes',
            formControlName: 'listCnpj',
            valor: cnpjsEmitentes,
            valorExibicao: this.listaEmpresas
                .filter(empresa => cnpjsEmitentes.includes(empresa.cnpj))
                .map(empresa => empresa.nomeEmpresa)
        });
        filtrosMapeados.push({
            label: 'Período (De)',
            formControlName: 'dataDe',
            valor: formatDate(dataDe, 'yyyy-MM-dd', 'pt-BR'),
            valorExibicao: dataDe.toLocaleDateString('pt-BR')
        });
        filtrosMapeados.push({
            label: 'Período (Até)',
            formControlName: 'dataAte',
            valor: formatDate(dataAte, 'yyyy-MM-dd', 'pt-BR'),
            valorExibicao: dataAte.toLocaleDateString('pt-BR')
        });
        if (formValue.pesquisar) {
            filtrosMapeados.push({ label: 'Pesquisa', formControlName: 'pesquisar', valor: formValue.pesquisar });
        }
        if (formValue.serie) {
            filtrosMapeados.push({ label: 'Série', formControlName: 'serie', valor: formValue.serie });
        }
        if (formValue.cfop) {
            filtrosMapeados.push({ label: 'CFOP', formControlName: 'cfop', valor: formValue.cfop });
        }
        if (formValue.isCacnelada !== null && formValue.isCacnelada !== undefined) {
            filtrosMapeados.push({
                label: 'Status',
                formControlName: 'isCacnelada',
                valor: formValue.isCacnelada,
                valorExibicao: formValue.isCacnelada ? 'Canceladas' : 'Autorizadas'
            });
        }

        const dialogData: ExtracaoDadosData = {
            titulo: titulo,
            tipoExtracao: idTipoExtracao,
            origemPedidoExportacao: OrigemPedidoExportacaoEnum.NotasFiscaisPainelContador,
            filtros: filtrosMapeados,
            possuiAutomacao: true,
        };

        this.dialog.open(ExtracaoDadosModalComponent, {
            data: dialogData,
            width: '800px',
            maxWidth: '95vw',
            maxHeight: '90vh',
            disableClose: true
        });
    }

    abrirRelatorioCfop(): void {
        const form = this.filterForm.getRawValue();
        const { dataDe, dataAte } = this.getPeriodo();
        const cnpjsSelecionados = this.cnpjsEmitentes;

        const request: GetAllPainelContadorRequest = {
            tiposNota: form.tiposNota ?? [],
            listCnpj: cnpjsSelecionados,
            dataDe,
            dataAte,
            pesquisar: form.pesquisar ?? '',
            cfop: form.cfop ?? '',
            isCacnelada: form.isCacnelada ?? null,
            serie: form.serie ?? ''
        };

        const idsTipos = form.tiposNota || [];
        // Estrutura composta: filtros (para a API) e display (para visualização).
        this.dialog.open(RelatorioCfopModalComponent, {
            width: '1100px',
            maxWidth: '95vw',
            maxHeight: '90vh',
            data: {
                filtros: request,
                display: {
                    empresas: this.listaEmpresas.filter(e => cnpjsSelecionados.includes(e.cnpj)),
                    tiposNota: this.listaModeloDocumento.filter(t => idsTipos.includes(t.idModeloDocumento))
                }
            },
            disableClose: true
        });
    }

    /** Presets calculados no dia local; o intervalo usa as datas digitadas. Meia-noite local, como o datepicker. */
    private getPeriodo(): { dataDe: Date; dataAte: Date } {
        const value = this.filterForm.getRawValue();
        if (this.periodoSelecionado === PeriodoBuscaEnum.DoIntervalo && value.dataDe && value.dataAte)
            return { dataDe: value.dataDe, dataAte: value.dataAte };

        const hoje = new Date();
        hoje.setHours(0, 0, 0, 0);
        const dataDe = new Date(hoje);
        switch (this.periodoSelecionado) {
            case PeriodoBuscaEnum.Hoje:
                break;
            case PeriodoBuscaEnum.DaSemana:
                dataDe.setDate(hoje.getDate() - 6);
                break;
            case PeriodoBuscaEnum.DoMes:
                dataDe.setDate(1);
                break;
            default:
                dataDe.setDate(hoje.getDate() - 29);
                break;
        }
        return { dataDe, dataAte: hoje };
    }

    pesquisarCfop(): void {
        if (this.filterForm.get('cfop')?.disabled) return;
        const ref = this.dialog.open(PesquisaCodigoTributacaoModalComponent, {
            width: '700px',
            maxWidth: '95vw',
            maxHeight: '85vh',
            panelClass: 'pesquisa-codigo-tributacao-dialog',
            data: {
                titulo: 'Pesquisar CFOP',
                buscarFn: (pesquisa: string) => this.selectPesquisavelService
                    .getSelectValues<{ codigo?: string; descricao: string }>(environment.urlApiMotorFiscal + 'Lookup/cfop', pesquisa)
                    .pipe(
                        map(list => ({
                            isError: false,
                            itens: list.map(i => ({ codigo: String(i.codigo ?? ''), descricao: i.descricao })),
                        })),
                        catchError(() => of({ isError: true, itens: [] })),
                    ),
                permitirManual: false,
                registrosIniciais: 20,
                valorInicial: this.filterForm.get('cfop')?.value ?? undefined,
            } satisfies PesquisaCodigoTributacaoModalData,
        });
        ref.afterClosed().subscribe((result: PesquisaCodigoTributacaoModalResult | null) => {
            if (!result?.selecionado) return;
            this.filterForm.get('cfop')?.setValue(result.selecionado.codigo.replace(/\D/g, ''));
            this.filterForm.get('cfop')?.markAsDirty();
        });
    }
}
